<!--
 * @Description:
 * @LastEditTime: 2024-02-02 10:41:55
 * @LastEditors: 何俊峰
 * @Author: 何俊峰
 * @Date: 2023-03-15 13:38:52
-->
<template>
<div id="app">
    <router-view/>
</div>
</template>
<script>
import config from '@/config/index'
export default {
    name: 'app',
    data() {
        return {
        };
    },
    components: {

    },
	created() {
    document.title = config.txt.title;
  }
}
</script>

<style>
#app {

}
.amap-container{
	background-color: rgb(0, 0, 0, 0)!important;
	background-image: none!important;
}
.el-tooltip__popper{
	max-width:60vw;
}
.v-modal{
  /* z-index: 99!important; */
}
.edui-default .edui-toolbar .edui-button .edui-button-wrap{
  border: 1px solid transparent;
}
.el-dialog__wrapper{
  /* z-index: 100!important; */
}
  .edui-default{
    line-height: initial!important;
  }


.customer_info_box{
  background: #05132C;
  border: 1px solid #20A5FD;
  box-shadow: 4px 4px 10px 1px rgba(0,0,0,0.31);
  position: relative;
  z-index: 13;
  overflow: hidden;
}
.customer_top{
  position: relative;
  min-height: 180px;
  display: flex;
}
.customer_bottom{
  position: relative;
  min-height: 180px;
  display: flex;
}
.customer_top_1{
  flex: 1;
  max-width: calc(100% - 110px);
}
.customer_avatar_box{
  width: 100px;
  height: 132px;
  margin-right: 8px;
  margin-top: 40px;
  padding: 5px;
  background: linear-gradient(to bottom, #034083, #061B3A);
}
.customer_avatar{
  width: 100%;
  object-fit: cover;
  height: 100%;
}
.customer_content{
	padding: 10px;
	line-height: 28px;
	color: #fff;
	font-size: 12px;
  font-weight: 400;
}

.titleBg{
  position: absolute;
  top: 0;
  left: 0;
  width: 434px;
  height: 33px;
}
.customer_name{
  position: relative;
  z-index: 22;
  line-height: 33px;
  color: #fff;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  padding-left: 13px;
}
.customer_name:before{
  content: '|';
  font-size: 13px;
  padding-right: 8px;
  font-weight: bold;
  position: relative;
  top: -2px;
}
.left-top-sharp{
	position: absolute;
	top: 0;
	left: 0;
	transform: rotate(180deg);
}
.right-top-sharp{
	position: absolute;
	top: 0;
	right: 0;
	transform: rotate(270deg);
}
.left-bottom-sharp{
	position: absolute;
	bottom: 0;
	left: 0;
	transform: rotate(90deg);
}
.right-bottom-sharp{
	position: absolute;
	bottom: 0;
	right: 0;
	/* transform: rotate(180deg); */
}
.el-date-editor .el-range-separator{
	width: 7%!important;
}

.myArea .el-radio{
	position: absolute;
	width: 100%;
	height: 100%;
	opacity: 0;
}
.mce-notification-warning{
  display: none!important;
}
</style>
